<div class="card trade_card h-100 d-flex flex-column border border-secondary" style="background-color: #1e2026;">

  <div class="card-header d-flex justify-content-between align-items-center py-2 border-bottom border-secondary"
    style="flex-shrink: 0; min-height: 50px; background-color: #1e2026;">
    <h5 class="mb-0 text-white">Order Book</h5>

    <div class="d-flex gap-2">
      <button class="btn btn-sm btn-outline-secondary p-1 d-flex align-items-center justify-content-center"
        style="width: 24px; height: 24px;" (click)="showDiv1()" title="Sell Orders Only">
        <i class="bi bi-graph-down text-danger" style="font-size: 0.75rem;"></i>
      </button>
      <button class="btn btn-sm btn-outline-secondary p-1 d-flex align-items-center justify-content-center"
        style="width: 24px; height: 24px;" (click)="showDiv2()" title="Buy Orders Only">
        <i class="bi bi-graph-up text-success" style="font-size: 0.75rem;"></i>
      </button>
      <button class="btn btn-sm btn-outline-secondary p-1 d-flex align-items-center justify-content-center"
        style="width: 24px; height: 24px;" (click)="showDivs()" title="Order Book">
        <i class="bi bi-list text-white" style="font-size: 0.75rem;"></i>
      </button>
    </div>
  </div>

  <div class="card-body p-0 d-flex flex-column" style="overflow: hidden;">

    <div class="d-flex text-secondary border-bottom border-secondary px-2 py-1"
      style="font-size: 0.7rem; background-color: #161a1e; flex-shrink: 0;">
      <div class="col-4 text-start">Price</div>
      <div class="col-4 text-end">Amount</div>
      <div class="col-4 text-end">Total</div>
    </div>

    <div class="flex-grow-1 position-relative" *ngIf="isDiv1Visible" style="overflow: hidden;">

      <div class="custom-scrollbar px-2"
        style="position: absolute; top: 0; bottom: 0; left: 0; right: 0; overflow-y: auto; display: flex; flex-direction: column-reverse;">

        <div *ngFor="let order of sellOrder" class="order-row d-flex align-items-center py-1 position-relative"
          (click)="handleClickOrder(order.price, order.quantity, 'sell')"
          style="cursor: pointer; min-height: 20px; flex-shrink: 0;">

          <div class="depth-bar bg-danger" [ngStyle]="{ width: calculateBarWidth(order.price * order.quantity) }"></div>

          <div class="col-4 text-danger text-start position-relative fw-bold" style="font-size: 0.75rem;">
            {{ longDecimals(truncateDecimals(order.price, tradePair.secondFloatDigit)) }}
          </div>
          <div class="col-4 text-white text-end position-relative" style="font-size: 0.75rem;">
            {{ longDecimals(truncateDecimals(order.quantity, tradePair.firstFloatDigit)) }}
          </div>
          <div class="col-4 text-secondary text-end position-relative" style="font-size: 0.75rem;">
            {{ longDecimals(truncateDecimals(order.price * order.quantity, tradePair.secondFloatDigit)) }}
          </div>
        </div>

      </div>
    </div>

    <div class="d-flex align-items-center justify-content-center py-2 border-top border-bottom border-secondary"
      style="background-color: #161a1e; flex-shrink: 0; z-index: 2;">
      <h5 class="mb-0 fw-bold me-2" [ngClass]="marketData.change > 0 ? 'text-success' : 'text-danger'">
        <span *ngIf="tradePair.secondCurrencySymbol == 'INR'">&#x20b9;</span>
        {{ longDecimals(truncateDecimals(marketData.markPrice, tradePair.secondFloatDigit)) }}
      </h5>
      <i class="bi fs-5"
        [ngClass]="'bi-arrow-' +(marketData.change > 0 ? 'up' : 'down') + '-short ' + (marketData.change > 0 ? 'text-success' : 'text-danger')"></i>
    </div>

    <div class="flex-grow-1 position-relative" *ngIf="isDiv2Visible" style="overflow: hidden;">

      <div class="custom-scrollbar px-2"
        style="position: absolute; top: 0; bottom: 0; left: 0; right: 0; overflow-y: auto;">

        <div *ngFor="let order of buyOrder" class="order-row d-flex align-items-center py-1 position-relative"
          (click)="handleClickOrder(order.price, order.quantity, 'buy')" style="cursor: pointer; min-height: 20px;">

          <div class="depth-bar bg-success" [ngStyle]="{ width: calculateBarWidth(order.price * order.quantity) }">
          </div>

          <div class="col-4 text-success text-start position-relative fw-bold" style="font-size: 0.75rem;">
            {{ longDecimals(truncateDecimals(order.price, tradePair.secondFloatDigit)) }}
          </div>
          <div class="col-4 text-white text-end position-relative" style="font-size: 0.75rem;">
            {{ longDecimals(truncateDecimals(order.quantity, tradePair.firstFloatDigit)) }}
          </div>
          <div class="col-4 text-secondary text-end position-relative" style="font-size: 0.75rem;">
            {{ longDecimals(truncateDecimals(order.price * order.quantity, tradePair.secondFloatDigit)) }}
          </div>
        </div>

      </div>
    </div>

  </div>
</div>